import { Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AuthFormComponent, CustomButton, TextInput } from "../../components";
import { LoginCredentials } from "../../models/login_credentials";
import {
  resetPasswordRequest,
  resetRequest,
  submitUserRequest,
} from "../../store/slices/user-slice";
import { AppDispatch, RootState } from "../../store/types/store";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [conf_password, setConfPassword] = useState<string>("");
  const [step, setStep] = useState<number>(1);
  const [otp, setOtp] = useState<string>("");
  const dispatch: AppDispatch = useDispatch();
  const [emailForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const navigate = useNavigate();

  const { emailSendResponse, loading, resetResponse } = useSelector(
    (state: RootState) => state.user
  );

  const onFinish = async (values: LoginCredentials) => {
    try {
      const validatedValues = await emailForm.validateFields();
      console.log(
        "All fields are valid. Submitting form with values:",
        validatedValues
      );
      const payload = {
        email: values.email,
        verificationType: "code",
      };
      dispatch(resetRequest(payload));
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  useEffect(() => {
    console.log("emailSendResponse", emailSendResponse);
    if (emailSendResponse?.message == "Password reset email sent!") {
      setStep(step + 1);
    }
  }, [emailSendResponse]);

  useEffect(() => {
    console.log("emailSendResponse", resetResponse);
    if (resetResponse.message == "Password reset successful!") {
      navigate('/');
    }
  }, [resetResponse]);

  const onSubmitPassowrd = async () => {
    try {
      const validatedValues = await passwordForm.validateFields();
      console.log(
        "All fields are valid. Submitting form with values:",
        validatedValues
      );
      const payload = {
        email: email,
        verificationType: "code",
        verificationHashOrCode: otp,
        newPassword: password,
      };
      dispatch(resetPasswordRequest(payload));
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  return step == 1 ? (
    <AuthFormComponent
      header={"Symmatics Core"}
      description={"Enter your email to reset your password"}
      title="Reset passowrd"
    >
      <Form
        form={emailForm}
        name="email_varify"
        onFinish={onFinish}
        autoComplete="off"
      >
        <TextInput
          className={"mb-3"}
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please input your email!",
            },
          ]}
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          label="Email Address"
        />
        <CustomButton
          wrapperClass="d-grid"
          btnType={"primary"}
          btnClass="btn-secondary"
          btnText="Verify email"
          loading={loading}
          disabled={loading}
        />
      </Form>
    </AuthFormComponent>
  ) : step == 2 ? (
    <AuthFormComponent
      header={"Symmatics Core"}
      description={
        "Sign up to access your account and manage Symmatics core functionalities"
      }
      title="Sign Up"
    >
      <Input.OTP
        formatter={(str) => str.toUpperCase()}
        onChange={(text: any) => {
          let otpValue = text;
          setOtp(otpValue);
          if (otpValue.length === 6) {
            setStep(step + 1);
          }
        }}
        value={otp}
      />
    </AuthFormComponent>
  ) : (
    <AuthFormComponent
      header={"Symmatics Core"}
      description={"Enter your new password"}
      title="Reset passowrd"
    >
      <Form
        form={passwordForm}
        name="password_reset"
        onFinish={onSubmitPassowrd}
        autoComplete="off"
      >
        <TextInput
          password
          className={"mb-3"}
          name="password"
          rules={[
            {
              required: true,
              message: "Password is required!",
            },
          ]}
          placeholder="Enter new password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          label="New Password"
        />
        <TextInput
          password
          className={"mb-3"}
          name="conf_password"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Please confirm your password!" },
            ({ getFieldValue }: any) => ({
              validator(_: unknown, value: string) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The two passwords do not match!")
                );
              },
            }),
          ]}
          placeholder="Confirm your password"
          onChange={(e) => setConfPassword(e.target.value)}
          value={conf_password}
          label="Confirm password"
        />
        <CustomButton
          wrapperClass="d-grid"
          btnType={"primary"}
          btnClass="btn-secondary"
          btnText="Reset"
          loading={loading}
          disabled={loading}
        />
      </Form>
    </AuthFormComponent>
  );
};

export default ForgotPassword;
